import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  KIOSK_CART_PRODUCTS_LIST_BLOCK_DATA_SOURCE,
  KioskCartProductsListBlockDataSource,
} from './kiosk-cart-products-list-block-view-model';
import { KioskCartProductsListBlockPreviewDataSource } from './kiosk-cart-products-list-block-preview-data-source';
import { KioskCartProductsListBlockStoreDataSource } from './kiosk-cart-products-list-block-store-data-source';

export function provideKioskCartProductsListBlockDataSource(): Provider[] {
  return [
    KioskCartProductsListBlockStoreDataSource,
    KioskCartProductsListBlockPreviewDataSource,
    {
      provide: KIOSK_CART_PRODUCTS_LIST_BLOCK_DATA_SOURCE,
      useFactory: (): KioskCartProductsListBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(KioskCartProductsListBlockPreviewDataSource)
          : inject(KioskCartProductsListBlockStoreDataSource);
      },
    },
  ];
}
